import React, { Fragment, useEffect, useState } from 'react';
import {
	useWindowWidth,
	chkMobile,
	formatProgramDate,
	generateTimeSlots,
	getConvertMinutes,
	getHallName,
	insertEmptyPrograms,
	noneFilter,
} from '../js/calculator';

const TimeTableThirty = ({
	lang,
	programList,
	selectFirstDay,
	setSelectFirstDay,
	selectSecondDay,
	setSelectSecondDay,
	hallId,
	setHallId,
	onFloat,
	onLive,
	clickLive,
	programListLength,
	timeHeight,
	programPop,
	setProgramPop,
	popContents,
	setPopContents,
	getSpeakerNames,
	getVideopopData,
	isTrack,
	openSpeaker,
	openModerator,
	toggleClose,
	videoData,
	toggleOpen,
	videoPop,
	onEng,
	setOnEng,
	onKor,
	setOnKor,
	setPopUuid,
	popClose,
	selectYear,
	titleFont,
	descFont,
	handleLanguageChange,
	showPlayer,
}) => {
	const isMobile = useWindowWidth();
	const filteredSpeakers = num => {
		return popContents?.speakerInfoDtos?.filter(el => el?.speakerType === num) || [];
	};

	return (
		<div className="schedule-all-wrapper">
			{onFloat && (
				<div className={`live_fixed ${onLive ? 'clicked' : ''} desktop`}>
					<button
						onClick={() => {
							clickLive();
							if (onLive) {
								window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
								window.location.reload();
							} else {
								document
									.getElementById('program-now')
									.scrollIntoView({ behavior: 'smooth', block: 'end' });
							}
						}}
					>
						{onLive ? (
							<span>{lang === 'en' ? 'Entire Schedule' : '스케쥴 전체보기'}</span>
						) : (
							<span>{lang === 'en' ? 'Watch Live' : 'LIVE 바로보기'}</span>
						)}
					</button>
					<div className="circle_ani">
						<svg className="loader" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
							<circle className="internal-circle" cx="60" cy="60" r="30"></circle>
						</svg>
					</div>
				</div>
			)}
			{selectYear !== '2020' && (
				<div className="link_tab">
					<div className="inner">
						<ul className="program-top-wrapper">
							<li
								className={`${selectFirstDay ? 'active1' : ''}`}
								onClick={() => {
									setSelectFirstDay(true);
									setSelectSecondDay(false);
									setHallId(0);
								}}
							>
								<a>{formatProgramDate(programList?.firstDay)}</a>
							</li>
							<li
								className={`${selectSecondDay ? 'active1' : ''}`}
								onClick={() => {
									setSelectFirstDay(false);
									setSelectSecondDay(true);
									setHallId(0);
								}}
							>
								<a>{formatProgramDate(programList?.secondDay)}</a>
							</li>
						</ul>
					</div>
				</div>
			)}
			<div className="tab_menu mobile">
				<ul>
					{programList !== undefined &&
						programList?.trackList?.map((ele, idx) => {
							return (
								<li
									className={idx === hallId ? 'active2' : ''}
									key={idx}
									onClick={() => {
										if (isMobile) {
											setHallId(idx);
											if (idx === hallId) {
												document.getElementById(`program_group_${idx + 1}`).style.display ===
													'block';
											}
										}
									}}
								>
									<a>
										{`Track${idx + 1}`}
										<em>{getHallName(idx)}</em>
									</a>
								</li>
							);
						})}
				</ul>
			</div>
			<div className="schedule_table">
				<div className="timeline">
					<ul>
						{programList !== undefined &&
							generateTimeSlots(programList?.firstStart, programList?.lastEnd)?.map((ele, idx) => (
								<li key={idx}>
									<span>{ele}</span>
								</li>
							))}
					</ul>
				</div>
				<div className="schedule_area">
					{/* <div className="schedule_tt_wrap desktop">
              <div className="inner">
                <ul>
                  {programList?.trackList?.map((ele, idx) => <li className="schedule_tt" key={idx}><span>Track {idx + 1}</span></li>)}
                </ul>
              </div>
            </div> */}
					<ul className="program-group">
						<div className="program_group_wrap">
							{programList !== undefined &&
								programList?.trackList?.map((ele, idx) => (
									<li
										key={idx}
										style={{ width: isMobile ? '100%' : `${100 / programListLength}%` }}
									>
										<div className="schedule_tt">
											<span>
												Track {idx + 1}
												<em>{getHallName(idx)}</em>
											</span>
										</div>
									</li>
								))}
						</div>
						<div className="schedule_wrap_all">
							<div
								id="program_group_1"
								className="program_group"
								style={{
									width: isMobile ? '100%' : `${100 / programListLength}%`,
									display: isMobile ? (0 === hallId ? 'flex' : 'none') : 'flex',
								}}
							>
								{programList !== undefined &&
									programList?.trackList?.map((el, listIdx) =>
										el?.track1 === undefined
											? null
											: insertEmptyPrograms(
													el?.track1,
													programList?.firstStart,
													programList?.lastEnd,
												)?.map((ele, idx) => {
													let start = 0;
													let end = 0;
													start = getConvertMinutes(ele?.startTime);
													end = getConvertMinutes(ele?.endTime);
													let isTime = (
														<li
															id={ele?.videoSt === '2' ? 'program-now' : ''}
															key={idx}
															className="program-group-list"
															style={{ border: ele?.videoSt === '2' && '1px solid #EE0017' }}
														>
															<div
																className="program-place"
																style={{ height: `${timeHeight(end, start)}px` }}
															>
																<div className="program_time_font">
																	{ele?.startTime}~{ele?.endTime}
																</div>
																<div
																	className={titleFont(end, start)}
																	onClick={() => {
																		setProgramPop(true);
																		sessionStorage.setItem('programPop', 'true');
																		document.body.style.overflow = 'hidden';
																		setPopContents({
																			startTime: ele?.startTime,
																			endTime: ele?.endTime,
																			programContent: ele?.programContent,
																			programName: ele?.programName,
																			speakerInfoDtos: ele?.speakerInfoDtos,
																		});
																	}}
																>
																	{ele?.programName}
																</div>
																<div className={descFont(end, start)}>
																	{getSpeakerNames(ele?.speakerInfoDtos, lang)}
																</div>
																{ele?.videoSt === '1' && (
																	<div className="btn_wrap btn_type2">
																		<div className="type2_default">
																			<span>COMING SOON </span>
																		</div>
																	</div>
																)}
																{ele?.videoSt === '2' && (
																	<>
																		<div
																			className="btn_wrap btn_type3"
																			onClick={() => {
																				// Promise를 사용하여 비동기 작업 처리
																				Promise.resolve(getVideopopData(ele?.programId)).then(
																					() => {
																						setPopContents({
																							startTime: ele?.startTime,
																							endTime: ele?.endTime,
																							programContent: ele?.programContent,
																							programName: ele?.programName,
																							speakerInfoDtos: ele?.speakerInfoDtos,
																						});
																					},
																				);
																			}}
																		>
																			<a>
																				<span>LIVE</span>
																				<span className="program-title-hidden">
																					{ele?.programName}
																				</span>
																			</a>
																		</div>
																		<img />
																		<div className="live_icon">
																			<img src="https://news.chosun.com/myj/alc_timetable/img/live_icon.png" />
																		</div>
																	</>
																)}
																{ele?.videoSt === '3' && (
																	<div
																		className="btn_wrap btn_type1"
																		onClick={() => {
																			// Promise를 사용하여 비동기 작업 처리
																			Promise.resolve(getVideopopData(ele?.programId)).then(() => {
																				setPopContents({
																					startTime: ele?.startTime,
																					endTime: ele?.endTime,
																					programContent: ele?.programContent,
																					programName: ele?.programName,
																					speakerInfoDtos: ele?.speakerInfoDtos,
																				});
																			});
																		}}
																	>
																		<a>
																			<span>VOD</span>
																			<span className="program-title-hidden">
																				{ele?.programName}
																			</span>
																		</a>
																	</div>
																)}
																{ele?.videoSt === '4' && (
																	<div className="btn_wrap btn_type2">
																		<div className="type2_default">
																			<span>{lang === 'en' ? 'Preparing VOD' : 'VOD 준비중'}</span>
																		</div>
																	</div>
																)}
															</div>
														</li>
													);
													let noTime = <li key={idx} className="program-group-noList"></li>;
													if (ele?.programName !== '') {
														return isTime;
													} else {
														return noTime;
													}
												}),
									)}
							</div>
							<div
								id="program_group_2"
								className="program_group"
								style={{
									width: isMobile ? '100%' : `${100 / programListLength}%`,
									display: isMobile ? (1 === hallId ? 'flex' : 'none') : 'flex',
								}}
							>
								{programList !== undefined &&
									programList?.trackList?.map((el, listIdx) =>
										el?.track2 === undefined
											? null
											: insertEmptyPrograms(
													el?.track2,
													programList?.firstStart,
													programList?.lastEnd,
												)?.map((ele, idx) => {
													let start = 0;
													let end = 0;
													start = getConvertMinutes(ele?.startTime);
													end = getConvertMinutes(ele?.endTime);
													let isTime = (
														<li
															id={ele?.videoSt === '2' ? 'program-now' : ''}
															key={idx}
															className="program-group-list"
															style={{ border: ele?.videoSt === '2' && '1px solid #EE0017' }}
														>
															<div
																className="program-place"
																style={{ height: `${timeHeight(end, start)}px` }}
															>
																<div className="program_time_font">
																	{ele?.startTime}~{ele?.endTime}
																</div>
																<div
																	className={titleFont(end, start)}
																	onClick={() => {
																		setProgramPop(true);
																		sessionStorage.setItem('programPop', 'true');
																		document.body.style.overflow = 'hidden';
																		setPopContents({
																			startTime: ele?.startTime,
																			endTime: ele?.endTime,
																			programContent: ele?.programContent,
																			programName: ele?.programName,
																			speakerInfoDtos: ele?.speakerInfoDtos,
																		});
																	}}
																>
																	{ele?.programName}
																</div>
																<div className={descFont(end, start)}>
																	{getSpeakerNames(ele?.speakerInfoDtos, lang)}
																</div>
																{ele?.videoSt === '1' && (
																	<div className="btn_wrap btn_type2">
																		<div className="type2_default">
																			<span>COMING SOON </span>
																		</div>
																	</div>
																)}
																{ele?.videoSt === '2' && (
																	<>
																		<div
																			className="btn_wrap btn_type3"
																			onClick={() => {
																				// Promise를 사용하여 비동기 작업 처리
																				Promise.resolve(getVideopopData(ele?.programId)).then(
																					() => {
																						setPopContents({
																							startTime: ele?.startTime,
																							endTime: ele?.endTime,
																							programContent: ele?.programContent,
																							programName: ele?.programName,
																							speakerInfoDtos: ele?.speakerInfoDtos,
																						});
																					},
																				);
																			}}
																		>
																			<a>
																				<span>LIVE</span>
																				<span className="program-title-hidden">
																					{ele?.programName}
																				</span>
																			</a>
																		</div>
																		<img />
																		<div className="live_icon">
																			<img src="https://news.chosun.com/myj/alc_timetable/img/live_icon.png" />
																		</div>
																	</>
																)}
																{ele?.videoSt === '3' && (
																	<div
																		className="btn_wrap btn_type1"
																		onClick={() => {
																			// Promise를 사용하여 비동기 작업 처리
																			Promise.resolve(getVideopopData(ele?.programId)).then(() => {
																				setPopContents({
																					startTime: ele?.startTime,
																					endTime: ele?.endTime,
																					programContent: ele?.programContent,
																					programName: ele?.programName,
																					speakerInfoDtos: ele?.speakerInfoDtos,
																				});
																			});
																		}}
																	>
																		<a>
																			<span>VOD</span>
																			<span className="program-title-hidden">
																				{ele?.programName}
																			</span>
																		</a>
																	</div>
																)}
																{ele?.videoSt === '4' && (
																	<div className="btn_wrap btn_type2">
																		<div className="type2_default">
																			<span>{lang === 'en' ? 'Preparing VOD' : 'VOD 준비중'}</span>
																		</div>
																	</div>
																)}
															</div>
														</li>
													);
													let noTime = <li key={idx} className="program-group-noList"></li>;
													if (ele?.programName !== '') {
														return isTime;
													} else {
														return noTime;
													}
												}),
									)}
							</div>
							<div
								id="program_group_3"
								className="program_group"
								style={{
									width: isMobile ? '100%' : `${100 / programListLength}%`,
									display: isMobile ? (2 === hallId ? 'flex' : 'none') : 'flex',
								}}
							>
								{programList !== undefined &&
									programList?.trackList?.map((el, listIdx) =>
										el?.track3 === undefined
											? null
											: insertEmptyPrograms(
													el?.track3,
													programList?.firstStart,
													programList?.lastEnd,
												)?.map((ele, idx) => {
													let start = 0;
													let end = 0;
													start = getConvertMinutes(ele?.startTime);
													end = getConvertMinutes(ele?.endTime);
													let isTime = (
														<li
															id={ele?.videoSt === '2' ? 'program-now' : ''}
															key={idx}
															className="program-group-list"
															style={{ border: ele?.videoSt === '2' && '1px solid #EE0017' }}
														>
															<div
																className="program-place"
																style={{ height: `${timeHeight(end, start)}px` }}
															>
																<div className="program_time_font">
																	{ele?.startTime}~{ele?.endTime}
																</div>
																<div
																	className={titleFont(end, start)}
																	onClick={() => {
																		setProgramPop(true);
																		sessionStorage.setItem('programPop', 'true');
																		document.body.style.overflow = 'hidden';
																		setPopContents({
																			startTime: ele?.startTime,
																			endTime: ele?.endTime,
																			programContent: ele?.programContent,
																			programName: ele?.programName,
																			speakerInfoDtos: ele?.speakerInfoDtos,
																		});
																	}}
																>
																	{ele?.programName}
																</div>
																<div className={descFont(end, start)}>
																	{getSpeakerNames(ele?.speakerInfoDtos, lang)}
																</div>
																{ele?.videoSt === '1' && (
																	<div className="btn_wrap btn_type2">
																		<div className="type2_default">
																			<span>COMING SOON </span>
																		</div>
																	</div>
																)}
																{ele?.videoSt === '2' && (
																	<>
																		<div
																			className="btn_wrap btn_type3"
																			onClick={() => {
																				// Promise를 사용하여 비동기 작업 처리
																				Promise.resolve(getVideopopData(ele?.programId)).then(
																					() => {
																						setPopContents({
																							startTime: ele?.startTime,
																							endTime: ele?.endTime,
																							programContent: ele?.programContent,
																							programName: ele?.programName,
																							speakerInfoDtos: ele?.speakerInfoDtos,
																						});
																					},
																				);
																			}}
																		>
																			<a>
																				<span>LIVE</span>
																				<span className="program-title-hidden">
																					{ele?.programName}
																				</span>
																			</a>
																		</div>
																		<img />
																		<div className="live_icon">
																			<img src="https://news.chosun.com/myj/alc_timetable/img/live_icon.png" />
																		</div>
																	</>
																)}
																{ele?.videoSt === '3' && (
																	<div
																		className="btn_wrap btn_type1"
																		onClick={() => {
																			// Promise를 사용하여 비동기 작업 처리
																			Promise.resolve(getVideopopData(ele?.programId)).then(() => {
																				setPopContents({
																					startTime: ele?.startTime,
																					endTime: ele?.endTime,
																					programContent: ele?.programContent,
																					programName: ele?.programName,
																					speakerInfoDtos: ele?.speakerInfoDtos,
																				});
																			});
																		}}
																	>
																		<a>
																			<span>VOD</span>
																			<span className="program-title-hidden">
																				{ele?.programName}
																			</span>
																		</a>
																	</div>
																)}
																{ele?.videoSt === '4' && (
																	<div className="btn_wrap btn_type2">
																		<div className="type2_default">
																			<span>{lang === 'en' ? 'Preparing VOD' : 'VOD 준비중'}</span>
																		</div>
																	</div>
																)}
															</div>
														</li>
													);
													let noTime = <li key={idx} className="program-group-noList"></li>;
													if (ele?.programName !== '') {
														return isTime;
													} else {
														return noTime;
													}
												}),
									)}
							</div>
							<div
								id="program_group_4"
								className="program_group"
								style={{
									width: isMobile ? '100%' : `${100 / programListLength}%`,
									display: isMobile ? (3 === hallId ? 'flex' : 'none') : 'flex',
								}}
							>
								{programList !== undefined &&
									programList?.trackList?.map((el, listIdx) =>
										el?.track4 === undefined
											? null
											: insertEmptyPrograms(
													el?.track4,
													programList?.firstStart,
													programList?.lastEnd,
												)?.map((ele, idx) => {
													let start = 0;
													let end = 0;
													start = getConvertMinutes(ele?.startTime);
													end = getConvertMinutes(ele?.endTime);
													let isTime = (
														<li
															id={ele?.videoSt === '2' ? 'program-now' : ''}
															key={idx}
															className="program-group-list"
															style={{ border: ele?.videoSt === '2' && '1px solid #EE0017' }}
														>
															<div
																className="program-place"
																style={{ height: `${timeHeight(end, start)}px` }}
															>
																<div className="program_time_font">
																	{ele?.startTime}~{ele?.endTime}
																</div>
																<div
																	className={titleFont(end, start)}
																	onClick={() => {
																		setProgramPop(true);
																		sessionStorage.setItem('programPop', 'true');
																		document.body.style.overflow = 'hidden';
																		setPopContents({
																			startTime: ele?.startTime,
																			endTime: ele?.endTime,
																			programContent: ele?.programContent,
																			programName: ele?.programName,
																			speakerInfoDtos: ele?.speakerInfoDtos,
																		});
																	}}
																>
																	{ele?.programName}
																</div>
																<div className={descFont(end, start)}>
																	{getSpeakerNames(ele?.speakerInfoDtos, lang)}
																</div>
																{ele?.videoSt === '1' && (
																	<div className="btn_wrap btn_type2">
																		<div className="type2_default">
																			<span>COMING SOON </span>
																		</div>
																	</div>
																)}
																{ele?.videoSt === '2' && (
																	<>
																		<div
																			className="btn_wrap btn_type3"
																			onClick={() => {
																				// Promise를 사용하여 비동기 작업 처리
																				Promise.resolve(getVideopopData(ele?.programId)).then(
																					() => {
																						setPopContents({
																							startTime: ele?.startTime,
																							endTime: ele?.endTime,
																							programContent: ele?.programContent,
																							programName: ele?.programName,
																							speakerInfoDtos: ele?.speakerInfoDtos,
																						});
																					},
																				);
																			}}
																		>
																			<a>
																				<span>LIVE</span>
																				<span className="program-title-hidden">
																					{ele?.programName}
																				</span>
																			</a>
																		</div>
																		<img />
																		<div className="live_icon">
																			<img src="https://news.chosun.com/myj/alc_timetable/img/live_icon.png" />
																		</div>
																	</>
																)}
																{ele?.videoSt === '3' && (
																	<div
																		className="btn_wrap btn_type1"
																		onClick={() => {
																			// Promise를 사용하여 비동기 작업 처리
																			Promise.resolve(getVideopopData(ele?.programId)).then(() => {
																				setPopContents({
																					startTime: ele?.startTime,
																					endTime: ele?.endTime,
																					programContent: ele?.programContent,
																					programName: ele?.programName,
																					speakerInfoDtos: ele?.speakerInfoDtos,
																				});
																			});
																		}}
																	>
																		<a>
																			<span>VOD</span>
																			<span className="program-title-hidden">
																				{ele?.programName}
																			</span>
																		</a>
																	</div>
																)}
																{ele?.videoSt === '4' && (
																	<div className="btn_wrap btn_type2">
																		<div className="type2_default">
																			<span>{lang === 'en' ? 'Preparing VOD' : 'VOD 준비중'}</span>
																		</div>
																	</div>
																)}
															</div>
														</li>
													);
													let noTime = <li key={idx} className="program-group-noList"></li>;
													if (ele?.programName !== '') {
														return isTime;
													} else {
														return noTime;
													}
												}),
									)}
							</div>
							{isTrack.track5 && (
								<div
									id="program_group_5"
									className="program_group"
									style={{
										width: isMobile ? '100%' : `${100 / programListLength}%`,
										display: isMobile ? (4 === hallId ? 'flex' : 'none') : 'flex',
									}}
								>
									{programList !== undefined &&
										programList?.trackList?.map((el, listIdx) =>
											el?.track5 === undefined
												? null
												: insertEmptyPrograms(
														el?.track5,
														programList?.firstStart,
														programList?.lastEnd,
													)?.map((ele, idx) => {
														let start = 0;
														let end = 0;
														start = getConvertMinutes(ele?.startTime);
														end = getConvertMinutes(ele?.endTime);
														let isTime = (
															<li
																id={ele?.videoSt === '2' ? 'program-now' : ''}
																key={idx}
																className="program-group-list"
																style={{ border: ele?.videoSt === '2' && '1px solid #EE0017' }}
															>
																<div
																	className="program-place"
																	style={{ height: `${timeHeight(end, start)}px` }}
																>
																	<div className="program_time_font">
																		{ele?.startTime}~{ele?.endTime}
																	</div>
																	<div
																		className={titleFont(end, start)}
																		onClick={() => {
																			setProgramPop(true);
																			sessionStorage.setItem('programPop', 'true');
																			document.body.style.overflow = 'hidden';
																			setPopContents({
																				startTime: ele?.startTime,
																				endTime: ele?.endTime,
																				programContent: ele?.programContent,
																				programName: ele?.programName,
																				speakerInfoDtos: ele?.speakerInfoDtos,
																			});
																		}}
																	>
																		{ele?.programName}
																	</div>
																	<div className={descFont(end, start)}>
																		{getSpeakerNames(ele?.speakerInfoDtos, lang)}
																	</div>
																	{ele?.videoSt === '1' && (
																		<div className="btn_wrap btn_type2">
																			<div className="type2_default">
																				<span>COMING SOON </span>
																			</div>
																		</div>
																	)}
																	{ele?.videoSt === '2' && (
																		<>
																			<div
																				className="btn_wrap btn_type3"
																				onClick={() => {
																					// Promise를 사용하여 비동기 작업 처리
																					Promise.resolve(getVideopopData(ele?.programId)).then(
																						() => {
																							setPopContents({
																								startTime: ele?.startTime,
																								endTime: ele?.endTime,
																								programContent: ele?.programContent,
																								programName: ele?.programName,
																								speakerInfoDtos: ele?.speakerInfoDtos,
																							});
																						},
																					);
																				}}
																			>
																				<a>
																					<span>LIVE</span>
																					<span className="program-title-hidden">
																						{ele?.programName}
																					</span>
																				</a>
																			</div>
																			<img />
																			<div className="live_icon">
																				<img src="https://news.chosun.com/myj/alc_timetable/img/live_icon.png" />
																			</div>
																		</>
																	)}
																	{ele?.videoSt === '3' && (
																		<div
																			className="btn_wrap btn_type1"
																			onClick={() => {
																				// Promise를 사용하여 비동기 작업 처리
																				Promise.resolve(getVideopopData(ele?.programId)).then(
																					() => {
																						setPopContents({
																							startTime: ele?.startTime,
																							endTime: ele?.endTime,
																							programContent: ele?.programContent,
																							programName: ele?.programName,
																							speakerInfoDtos: ele?.speakerInfoDtos,
																						});
																					},
																				);
																			}}
																		>
																			<a>
																				<span>VOD</span>
																				<span className="program-title-hidden">
																					{ele?.programName}
																				</span>
																			</a>
																		</div>
																	)}
																	{ele?.videoSt === '4' && (
																		<div className="btn_wrap btn_type2">
																			<div className="type2_default">
																				<span>
																					{lang === 'en' ? 'Preparing VOD' : 'VOD 준비중'}
																				</span>
																			</div>
																		</div>
																	)}
																</div>
															</li>
														);
														let noTime = <li key={idx} className="program-group-noList"></li>;
														if (ele?.programName !== '') {
															return isTime;
														} else {
															return noTime;
														}
													}),
										)}
								</div>
							)}
							{isTrack.track6 && (
								<div
									id="program_group_6"
									className="program_group"
									style={{
										width: isMobile ? '100%' : `${100 / programListLength}%`,
										display: isMobile ? (5 === hallId ? 'flex' : 'none') : 'flex',
									}}
								>
									{programList !== undefined &&
										programList?.trackList?.map((el, listIdx) =>
											el?.track6 === undefined
												? null
												: insertEmptyPrograms(
														el?.track6,
														programList?.firstStart,
														programList?.lastEnd,
													)?.map((ele, idx) => {
														let start = 0;
														let end = 0;
														start = getConvertMinutes(ele?.startTime);
														end = getConvertMinutes(ele?.endTime);
														let isTime = (
															<li
																id={ele?.videoSt === '2' ? 'program-now' : ''}
																key={idx}
																className="program-group-list"
																style={{ border: ele?.videoSt === '2' && '1px solid #EE0017' }}
															>
																<div
																	className="program-place"
																	style={{ height: `${timeHeight(end, start)}px` }}
																>
																	<div className="program_time_font">
																		{ele?.startTime}~{ele?.endTime}
																	</div>
																	<div
																		className={titleFont(end, start)}
																		onClick={() => {
																			setProgramPop(true);
																			sessionStorage.setItem('programPop', 'true');
																			document.body.style.overflow = 'hidden';
																			setPopContents({
																				startTime: ele?.startTime,
																				endTime: ele?.endTime,
																				programContent: ele?.programContent,
																				programName: ele?.programName,
																				speakerInfoDtos: ele?.speakerInfoDtos,
																			});
																		}}
																	>
																		{ele?.programName}
																	</div>
																	<div className={descFont(end, start)}>
																		{getSpeakerNames(ele?.speakerInfoDtos, lang)}
																	</div>
																	{ele?.videoSt === '1' && (
																		<div className="btn_wrap btn_type2">
																			<div className="type2_default">
																				<span>COMING SOON </span>
																			</div>
																		</div>
																	)}
																	{ele?.videoSt === '2' && (
																		<>
																			<div
																				className="btn_wrap btn_type3"
																				onClick={() => {
																					// Promise를 사용하여 비동기 작업 처리
																					Promise.resolve(getVideopopData(ele?.programId)).then(
																						() => {
																							setPopContents({
																								startTime: ele?.startTime,
																								endTime: ele?.endTime,
																								programContent: ele?.programContent,
																								programName: ele?.programName,
																								speakerInfoDtos: ele?.speakerInfoDtos,
																							});
																						},
																					);
																				}}
																			>
																				<a>
																					<span>LIVE</span>
																					<span className="program-title-hidden">
																						{ele?.programName}
																					</span>
																				</a>
																			</div>
																			<img />
																			<div className="live_icon">
																				<img src="https://news.chosun.com/myj/alc_timetable/img/live_icon.png" />
																			</div>
																		</>
																	)}
																	{ele?.videoSt === '3' && (
																		<div
																			className="btn_wrap btn_type1"
																			onClick={() => {
																				// Promise를 사용하여 비동기 작업 처리
																				Promise.resolve(getVideopopData(ele?.programId)).then(
																					() => {
																						setPopContents({
																							startTime: ele?.startTime,
																							endTime: ele?.endTime,
																							programContent: ele?.programContent,
																							programName: ele?.programName,
																							speakerInfoDtos: ele?.speakerInfoDtos,
																						});
																					},
																				);
																			}}
																		>
																			<a>
																				<span>VOD</span>
																				<span className="program-title-hidden">
																					{ele?.programName}
																				</span>
																			</a>
																		</div>
																	)}
																	{ele?.videoSt === '4' && (
																		<div className="btn_wrap btn_type2">
																			<div className="type2_default">
																				<span>
																					{lang === 'en' ? 'Preparing VOD' : 'VOD 준비중'}
																				</span>
																			</div>
																		</div>
																	)}
																</div>
															</li>
														);
														let noTime = <li key={idx} className="program-group-noList"></li>;
														if (ele?.programName !== '') {
															return isTime;
														} else {
															return noTime;
														}
													}),
										)}
								</div>
							)}
						</div>
					</ul>
				</div>
			</div>
			{programPop && (
				<>
					<div className="schedule_pop info_modal open">
						<div className="close_pop_wrap">
							<div
								className="close_pop"
								onClick={() => {
									setProgramPop(false);
									document.body.style.overflow = 'auto';
									toggleClose();
									sessionStorage.setItem('programPop', 'false');
								}}
							>
								<div className="modal_cont_wrap mCustomScrollbar _mCS_9 mCS-autoHide mCS_no_scrollbar">
									<img src="//news.chosun.com/myj/alc_timetable/img/close-active.png" />
								</div>
							</div>
						</div>
						<div className="inner">
							<div className="modal_cont_wrap">
								<div className="cont_top">
									<div className="modal_time">{`${popContents?.startTime}~${popContents?.endTime}`}</div>
									<div className="modal_title">{popContents?.programName}</div>
									<div className="modal_desc">{popContents?.programContent}</div>
								</div>
								<div className="seperate-line"></div>
								<div className="" style={{ display: 'flex', flexDirection: 'column' }}>
									<span className="info-title">
										{lang === 'en' ? 'Participants' : '참여자 정보'}
									</span>
									{filteredSpeakers(2).length > 0 && (
										<div className="cont_bot border-grey">
											<div className="modal_sm_title">{lang === 'en' ? 'Moderator' : '좌장'}</div>
											{filteredSpeakers(2).map((ele, idx) => {
												return (
													<div
														key={idx}
														id={`grey-${idx}`}
														className={`speaker_info ${idx === 0 ? 'first' : ''} ${openModerator === idx ? 'open' : ''}`}
													>
														<div className="dis_table">
															<div className="img">
																<span>
																	<img src={ele?.speakerImg} alt="" />
																</span>
															</div>
															<div className="txt">
																<div className="txt1">
																	{lang === 'en' ? ele?.speakerNmEn : ele?.speakerNmKr}
																</div>
																<div className="txt2">
																	{lang === 'en' ? ele?.speakerBelongEn : ele?.speakerBelongKr}
																</div>
															</div>
														</div>
														{idx === openModerator ? (
															<span
																className="more"
																onClick={() => {
																	toggleOpen(2, idx);
																}}
															>
																<span>{lang === 'en' ? 'Less' : '접기'}</span>
															</span>
														) : (
															<span
																className="more"
																onClick={() => {
																	toggleOpen(2, idx);
																}}
															>
																<span>{lang === 'en' ? 'More' : '더보기'}</span>
															</span>
														)}
														<div className={lang === 'en' ? 'grey_box' : 'grey_box kor'}>
															{lang === 'en' ? ele?.introEn : ele?.introKr}
														</div>
													</div>
												);
											})}
										</div>
									)}
									{filteredSpeakers(1).length > 0 && (
										<div className="cont_bot second-section">
											<div className="modal_sm_title">{lang === 'en' ? 'Speaker' : '연사'}</div>
											{filteredSpeakers(1).map((ele, idx) => {
												return (
													<div
														key={idx}
														id={`grey-${idx}`}
														className={`speaker_info ${idx === 0 ? 'first' : ''} ${openSpeaker === idx ? 'open' : ''}`}
													>
														<div className="dis_table">
															<div className="img">
																<span>
																	<img src={ele?.speakerImg} alt="" />
																</span>
															</div>
															<div className="txt">
																<div className="txt1">
																	{lang === 'en' ? ele?.speakerNmEn : ele?.speakerNmKr}
																</div>
																<div className="txt2">
																	{lang === 'en' ? ele?.speakerBelongEn : ele?.speakerBelongKr}
																</div>
															</div>
														</div>
														{idx === openSpeaker ? (
															<span
																className="more"
																onClick={() => {
																	toggleOpen(1, idx);
																}}
															>
																<span>{lang === 'en' ? 'Less' : '접기'}</span>
															</span>
														) : (
															<span
																className="more"
																onClick={() => {
																	toggleOpen(1, idx);
																}}
															>
																<span>{lang === 'en' ? 'More' : '더보기'}</span>
															</span>
														)}
														<div className={lang === 'en' ? 'grey_box' : 'grey_box kor'}>
															{lang === 'en' ? ele?.introEn : ele?.introKr}
														</div>
													</div>
												);
											})}
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
					<div
						className="schedule_pop_2024_bg"
						onClick={() => {
							setProgramPop(false);
							document.body.style.overflow = 'auto';
							toggleClose();
							sessionStorage.setItem('programPop', 'false');
						}}
					></div>
				</>
			)}
			{noneFilter.includes(videoData) === false && videoPop && (
				<div id="speaker_pop_wrapper fadeIn" className="layer-wrap speaker_pop_wrap">
					<div className="speaker_pop">
						<ul className="lang_btn">
							{videoData?.uuidEn && videoData.uuidEn !== '' && (
								<li
									onClick={() => {
										if (!onEng || (videoData?.uuidKr && videoData.uuidKr !== '')) {
											handleLanguageChange(true);
										}
									}}
								>
									<span className={onEng ? 'on' : ''}>ENG</span>
								</li>
							)}
							{videoData?.uuidKr && videoData.uuidKr !== '' && (
								<li
									onClick={() => {
										if (!onKor || (videoData?.uuidEn && videoData.uuidEn !== '')) {
											handleLanguageChange(false);
										}
									}}
								>
									<span className={onKor ? 'on' : ''}>KOR</span>
								</li>
							)}
						</ul>
						<div
							className="btn-layerClose"
							onClick={() => {
								popClose();
							}}
						></div>
						<div id="lang_en" className={`tab_cont tab_on_video`}>
							{showPlayer && (
								<div className="video_area">
									<div
										className="powa"
										id={`powa-${onEng ? videoData?.uuidEn : videoData?.uuidKr}`}
										data-uuid={onEng ? videoData?.uuidEn : videoData?.uuidKr}
										data-org="chosun"
										data-api="prod"
										data-env="prod"
									></div>
								</div>
							)}

							<div className="video_pop_title">
								{/* <div className="cate">{onEng ? videoData?.categoryEn : videoData?.categoryKr}</div> */}
								{/* <div className="tt">{onEng ? videoData?.videoNameEn : videoData?.videoNameEn}</div> */}
								<div className="tt">{popContents?.programName}</div>
							</div>
							{/* <div className="video_pop_speaker">
								<div className="modal_sm_title">{onEng ? 'Speaker' : '연사'}</div>
								{videoData?.speakerResponseList?.map((ele, idx) => (
									<div className={`speaker_info ${idx === 0 ? 'first' : ''}`} key={idx}>
										<div className="dis_table">
											<div className="img">
												<span>
													<img src={ele?.speakerImg} alt="" className="mCS_img_loaded" />
												</span>
											</div>
											<div className="txt">
												<div className="txt1">{onEng ? ele?.speakerNmEn : ele?.speakerNmKr}</div>
												<div className="txt2">
													{onEng ? ele?.speakerBelongEn : ele?.speakerBelongKr}
												</div>
											</div>
										</div>
									</div>
								))}
							</div> */}
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default TimeTableThirty;
